import { MathNormIcon } from './MathNormIcon';

/**
 * author: Michael Irigoyen
 * id 6C9569E6-55F1-48AF-A11C-2284315D0CE6
 * name math-norm
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/math-norm.svg
 * tags
 * - Math 
 * - Developer / Languages 
 */
export const CodeOrIcon = MathNormIcon;
export default CodeOrIcon